import { ThemedIllustration } from './themed-illustration';

const Light = () => (
  <svg width="300" height="240" viewBox="0 0 300 240" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <filter id="nf-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#0F172A" floodOpacity="0.10"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="nf-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#EEF2F7"/>
      </linearGradient>
    </defs>

    {/* Petri dish */}
    <g filter="url(#nf-shadow)" transform="translate(60 110)">
      <ellipse cx="100" cy="60" rx="100" ry="34" fill="url(#nf-body)"/>
      <ellipse cx="100" cy="56" rx="100" ry="34" fill="#FFFFFF"/>
      <ellipse cx="100" cy="56" rx="92" ry="28" fill="none"
               stroke="#1E3A8A" strokeOpacity="0.12" strokeWidth="2"/>
    </g>

    {/* Magnifying glass */}
    <g filter="url(#nf-shadow)" transform="translate(150 18)">
      <circle cx="60" cy="60" r="56" fill="url(#nf-body)"/>
      <circle cx="60" cy="60" r="44" fill="#FFFFFF" opacity="0.85"/>
      <circle cx="60" cy="60" r="44" fill="none" stroke="#1E3A8A"
              strokeOpacity="0.20" strokeWidth="2"/>
      <rect x="98" y="98" width="60" height="14" rx="7"
            transform="rotate(45 98 98)" fill="url(#nf-body)"/>
      {/* question mark */}
      <text x="60" y="78" textAnchor="middle"
            fontFamily="ui-sans-serif, system-ui, -apple-system, sans-serif"
            fontSize="56" fontWeight="700" fill="#1E3A8A" fillOpacity="0.45">?</text>
    </g>

    {/* Floating accent dots */}
    <g fill="#1E3A8A" opacity="0.18">
      <circle cx="40" cy="40" r="3"/>
      <circle cx="265" cy="50" r="3"/>
      <circle cx="50" cy="200" r="2.5"/>
      <circle cx="260" cy="200" r="2.5"/>
    </g>
  </svg>
);

const Dark = () => (
  <svg width="300" height="240" viewBox="0 0 300 240" fill="none"
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <filter id="nf-shadow-d" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6"/>
        <feOffset dx="0" dy="8" result="o"/>
        <feFlood floodColor="#000000" floodOpacity="0.45"/>
        <feComposite in2="o" operator="in"/>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <linearGradient id="nf-body-d" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#1F2937"/>
        <stop offset="100%" stopColor="#111827"/>
      </linearGradient>
    </defs>
    <g filter="url(#nf-shadow-d)" transform="translate(60 110)">
      <ellipse cx="100" cy="60" rx="100" ry="34" fill="url(#nf-body-d)"/>
      <ellipse cx="100" cy="56" rx="100" ry="34" fill="#1F2937"/>
      <ellipse cx="100" cy="56" rx="92" ry="28" fill="none"
               stroke="#60A5FA" strokeOpacity="0.20" strokeWidth="2"/>
    </g>
    <g filter="url(#nf-shadow-d)" transform="translate(150 18)">
      <circle cx="60" cy="60" r="56" fill="url(#nf-body-d)"/>
      <circle cx="60" cy="60" r="44" fill="#0F172A" opacity="0.6"/>
      <circle cx="60" cy="60" r="44" fill="none" stroke="#60A5FA"
              strokeOpacity="0.4" strokeWidth="2"/>
      <rect x="98" y="98" width="60" height="14" rx="7"
            transform="rotate(45 98 98)" fill="url(#nf-body-d)"/>
      <text x="60" y="78" textAnchor="middle"
            fontFamily="ui-sans-serif, system-ui, -apple-system, sans-serif"
            fontSize="56" fontWeight="700" fill="#60A5FA" fillOpacity="0.7">?</text>
    </g>
    <g fill="#60A5FA" opacity="0.28">
      <circle cx="40" cy="40" r="3"/>
      <circle cx="265" cy="50" r="3"/>
      <circle cx="50" cy="200" r="2.5"/>
      <circle cx="260" cy="200" r="2.5"/>
    </g>
  </svg>
);

export const NotFoundIllustration = () => (
  <ThemedIllustration light={<Light />} dark={<Dark />} />
);
